import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { Cookies } from "react-cookie";
import { fetchJSON } from "helpers/axios";

import {
  SIGNIN_USER,
  SIGNOUT_USER,
  APPLICANT_SIGNIN_USER,
  ADMIN_SIGNIN_USER,
  STUDENT_SIGNIN_USER,
  ALUMNI_SIGNIN_USER,
} from "constants/ActionTypes";
import {
  showAuthMessage,
  studentSignInSuccess,
  adminSignInSuccess,
  applicantSignInSuccess,
  alumniSigninSuccess,
  setSessionId,
  userSignOutSuccess,
  unsetPages,
  setPages,
  setStudentPages,
  unsetStudentPages
} from "actions/Auth";

const setSession = (user) => {
  let cookies = new Cookies();
  if (user) cookies.set("user", JSON.stringify(user), { path: "/" });
  else cookies.remove("user", { path: "/" });
};

function* applicantSignFunction({ payload }) {
  try {
    const { email, password } = payload;
    const activeSession = yield call(fetchJSON, "api/ActiveSessions?schId=1", null, "GET");
    const login = {
      Username: email,
      Password: password,
      SessionID: activeSession.Data[0].Academic_SessionID,
      userMode: "Applicant",
      schoolId: 1,
    };
    const response = yield call(fetchJSON, "api/Account/Login", login, "POST");
    if (response) {
      const signInUser = response;
      if (signInUser.Status === "Ok") {
        let user = signInUser.Data;
        user.token = signInUser.LoginToken;
        user.sid = signInUser.Data2;
        user.Applicant = signInUser.Data6;
        setSession(user);
        const response1 = yield call(
          fetchJSON,
          "api/ActiveSessions?schId=1",
          null,
          "GET"
        );
        if (response1.Status === "Ok") {
          const sessionID = response1.Data[0].Admission_SessionID;
          yield put(setSessionId(sessionID));
        } else {
          yield put(showAuthMessage("error in fetching API"));
        }
        yield put(applicantSignInSuccess(user));
      } else {
        yield put(showAuthMessage(signInUser.Message));
      }
    }
  } catch (error) {
    console.error("error: " + error);
    yield put(showAuthMessage("An error occurred."));
  }
}

function* adminSignFunction({ payload }) {
  try {
    const { email, password } = payload;
    const activeSession = yield call(fetchJSON, "api/ActiveSessions?schId=1", null, "GET");
    const login = {
      Username: email,
      Password: password,
      SessionID: activeSession.Data[0].Academic_SessionID,
      userMode: "Admin",
      schoolId: 1,
    };
    const response = yield call(fetchJSON, "api/Account/Login", login, "POST");
    if (response) {
      const signInUser = response;
      if (signInUser.Status === "Ok") {
        let user = signInUser.Data;
        user.token = signInUser.LoginToken;
        user.sid = signInUser.Data2;
        user.LastName = signInUser.Data.UsernameEmail;
        user.FirstName = "";
        user.Passport = signInUser.Data.passport;
        setSession(user);
        const response1 = yield call(
          fetchJSON,
          "api/ActiveSessions?schId=1",
          null,
          "GET"
        );
        if (response1.Status === "Ok") {
          const sessionID = response1.Data[0];
          yield put(setSessionId(sessionID));
          yield put(
            setPages(
              signInUser.Data5 === null || signInUser.Data5 === undefined
                ? []
                : signInUser.Data5
            )
          );
        } else {
          yield put(showAuthMessage("error in fetching API"));
        }
        yield put(adminSignInSuccess(user));
      } else {
        yield put(showAuthMessage(signInUser.Message));
      }
    }
  } catch (error) {
    console.error("error: " + error);
    yield put(showAuthMessage("An error occurred."));
  }
}

function* studentSignFunction({ payload }) {
  try {
    const activeSession = yield call(fetchJSON, "api/ActiveSessions?schId=1", null, "GET");
    const { email, password } = payload;
    const login = {
      Username: email,
      Password: password,
      SessionID: activeSession.Data[0].Academic_SessionID,
      userMode: "Student",
      schoolId: 1,
    };
    const response = yield call(fetchJSON, "api/Account/Login", login, "POST");
    if (response) {
      const signInUser = response;
      if (signInUser.Status === "Ok") {
        let user = signInUser.Data[0];
        let user2 = signInUser.Data2;
        user.token = signInUser.LoginToken;
        user.sid = signInUser.Data5;
        user.StudID = signInUser.Data6;
        user = { ...user, ...user2, ...user.StudentDetails };
        setSession(user);
        const response1 = yield call(
          fetchJSON,
          "api/ActiveSessions?schId=1",
          null,
          "GET"
        );
        if (response1.Status === "Ok") {
          const sessionID = response1.Data[0];
          yield put(setSessionId(sessionID));
          yield put(
            setStudentPages(
              signInUser.RoleData === null || signInUser.RoleData === undefined
                ? []
                : signInUser.RoleData
            )
          );
        } else {
          yield put(showAuthMessage("error in fetching API"));
        }
        yield put(studentSignInSuccess(user));
      } else {
        yield put(showAuthMessage(signInUser.Message));
      }
    }
  } catch (error) {
    console.error("error: " + error);
    yield put(showAuthMessage("An error occurred."));
  }
}

function* alumniSignFunction({ payload }) {
  try {
    const { matricNo, password } = payload;
    const login = {
      MatricNo: matricNo,
      Password: password,
    }
    const response = yield call(fetchJSON, "api/Login", login, "POST");
    if (response) {
      if (response.Status === "Ok") {
        let user = response?.Data?.userDetails;
        user.token = response?.Data?.token?.Result;
        setSession(user);
        yield put(alumniSigninSuccess(user));
      } else {
        yield put(showAuthMessage(response.Message));
      }
    }
  } catch (error) {
    console.error("error: " + error);
    yield put(showAuthMessage("An error occurred."));
  }
}

function* signInUserWithEmailPassword({ payload }) {
  const activeSession = yield call(fetchJSON, "api/ActiveSessions?schId=1", null, "GET");
  const { email, password } = payload;
  try {
    const login = {
      Username: email,
      Password: password,
      SessionID: activeSession.Data[0].Academic_SessionID,
      userMode: "Applicant",
      schoolId: 1,
    };
    const response = yield call(fetchJSON, "api/Account/Login", login, "POST");
    if (response) {
      const signInUser = response;
      if (signInUser.Status === "Ok") {
        let user = signInUser.Data;
        user.token = signInUser.LoginToken;
        user.sid = signInUser.Data2;
        setSession(user);
        const response1 = yield call(
          fetchJSON,
          "api/CurrentAdmSession/1",
          null,
          "GET"
        );
        if (response1.Status === "Ok") {
          const sessionID = response1.Data.SessionId;
          yield put(setSessionId(sessionID));
        } else {
          yield put(showAuthMessage("error in fetching API"));
        }
        yield put(applicantSignInSuccess(user));
      } else {
        yield put(showAuthMessage(signInUser.Message));
      }
    }
  } catch (error) {
    console.error("error: " + error);
    yield put(showAuthMessage("An error occurred."));
  }
}

function* signOut({ payload }) {
  try {
    const { sessionID, userMode } = payload;
    const response = yield call(
      fetchJSON,
      `api/Account/Logout?sessionID=${sessionID}&userMode=${userMode}`,
      null,
      "GET"
    );
    if (response.Status === "Ok") {
      setSession(null);
      yield put(userSignOutSuccess(userMode));
      userMode !== "student" ? yield put(unsetPages()) : yield put(unsetStudentPages());
      // yield put(userSignOutSuccess(signOutUser));
    } else {
      yield put(showAuthMessage("Unable to complete operation at the moment"));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* applicantSignIn() {
  yield takeEvery(APPLICANT_SIGNIN_USER, applicantSignFunction);
}

export function* adminSignIn() {
  yield takeEvery(ADMIN_SIGNIN_USER, adminSignFunction);
}

export function* studentSignIn() {
  yield takeEvery(STUDENT_SIGNIN_USER, studentSignFunction);
}
export function* alumniSignIn() {
  yield takeEvery(ALUMNI_SIGNIN_USER, alumniSignFunction);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(adminSignIn),
    fork(applicantSignIn),
    fork(studentSignIn),
    fork(alumniSignIn),
    fork(signOutUser),
  ]);
}
